import $4xgRo$lodashmerge from "lodash.merge";


const $cf8d6f6baaa06856$export$821aa83695b9c27 = 'scm';
const $cf8d6f6baaa06856$export$43d7bf4a2adcea1e = 'simple-consent-manager';



function $bdfcb402607a6bed$export$9b8b2ad360b4fa1b(label, callback, parentClass) {
    const className = (0, $cf8d6f6baaa06856$export$821aa83695b9c27) + '-button';
    const buttonElement = document.createElement('button');
    buttonElement.classList.add(className);
    buttonElement.role = 'button';
    buttonElement.innerHTML = label;
    buttonElement.addEventListener('click', callback);
    if (parentClass) buttonElement.classList.add(parentClass);
    return buttonElement;
}



function $0cd73e606a017c28$export$c46e3d6e889fd01a(description, id) {
    const className = (0, $cf8d6f6baaa06856$export$821aa83695b9c27) + '-description';
    const descriptionElement = document.createElement('p');
    descriptionElement.classList.add(className);
    descriptionElement.innerHTML = description;
    if (id) descriptionElement.id = id;
    return descriptionElement;
}



function $2c849848fb05fa8f$export$cebdc09f4d9da75c(source, alternative, width, height, alignment, parentClass) {
    const className = (0, $cf8d6f6baaa06856$export$821aa83695b9c27) + '-image';
    // Container
    const containerElement = document.createElement('div');
    containerElement.classList.add(className);
    // Inner
    const innerElement = document.createElement('div');
    innerElement.classList.add(className + '__inner');
    containerElement.appendChild(innerElement);
    if (parentClass) containerElement.classList.add(parentClass);
    if (width) innerElement.style.width = width;
    if (height) innerElement.style.height = height;
    switch(alignment){
        case 'left':
            containerElement.classList.add(className + '--alignment-left');
            break;
        case 'right':
            containerElement.classList.add(className + '--alignment-right');
            break;
        default:
            containerElement.classList.add(className + '--alignment-center');
            break;
    }
    // Image
    const imageElement = document.createElement('img');
    imageElement.classList.add(className + '__image');
    imageElement.src = source;
    if (alternative !== undefined) imageElement.alt = alternative;
    innerElement.appendChild(imageElement);
    return containerElement;
}



function $e43f2f3861aceab0$export$d43f0d7892afdfe3(url, label, target = '_self', parentClass) {
    const className = (0, $cf8d6f6baaa06856$export$821aa83695b9c27) + '-link';
    const linkElement = document.createElement('a');
    linkElement.classList.add(className);
    linkElement.href = url;
    linkElement.target = target;
    linkElement.innerHTML = label;
    if (parentClass) linkElement.classList.add(parentClass);
    return linkElement;
}



function $f414987ffcd7d03b$export$3320100c1b5de582(buttons) {
    const className = (0, $cf8d6f6baaa06856$export$821aa83695b9c27) + '-list-button';
    const listElement = document.createElement('ul');
    listElement.classList.add(className);
    buttons.forEach((button)=>{
        const itemElement = document.createElement('li');
        itemElement.classList.add(className + '__item');
        itemElement.appendChild(button);
        listElement.appendChild(itemElement);
    });
    return listElement;
}



function $5118421420f951af$export$69bf191433722f78(titleId, descriptionId) {
    const className = (0, $cf8d6f6baaa06856$export$821aa83695b9c27) + '-modal';
    const modalElement = document.createElement('div');
    modalElement.classList.add(className);
    modalElement.role = 'dialog';
    modalElement.ariaModal = 'false';
    modalElement.ariaLive = 'polite';
    modalElement.setAttribute('aria-labelledby', titleId);
    modalElement.setAttribute('aria-describedby', descriptionId);
    return modalElement;
}



function $6a89684121d6b392$export$553f274869ee0a8f(title, level, id) {
    const className = (0, $cf8d6f6baaa06856$export$821aa83695b9c27) + '-title';
    const titleElement = document.createElement(`h${level}`);
    titleElement.classList.add(className);
    titleElement.innerHTML = title;
    if (id) titleElement.id = id;
    return titleElement;
}


function $4261e957589a8239$export$5e5c8210e5686582(config, delineAllChoices, acceptAllChoices, configureCallback) {
    const className = (0, $cf8d6f6baaa06856$export$821aa83695b9c27) + '-home';
    const titleId = className + '-title';
    const descriptionId = className + '-description';
    const modalElement = (0, $5118421420f951af$export$69bf191433722f78)(titleId, descriptionId);
    const homeElement = document.createElement('div');
    homeElement.classList.add(className);
    modalElement.appendChild(homeElement);
    const { privacyPolicy: privacyPolicy } = config.translations[config.language];
    const { title: title, description: description, accept: accept, configure: configure, decline: decline } = config.translations[config.language].home;
    // Title
    const titleElement = (0, $6a89684121d6b392$export$553f274869ee0a8f)(title, 2, titleId);
    homeElement.appendChild(titleElement);
    // Image
    if (config.images?.home?.source) {
        const { source: source, alternative: alternative, width: width, height: height, alignment: alignment } = config.images.home;
        const imageElement = (0, $2c849848fb05fa8f$export$cebdc09f4d9da75c)(source, alternative, width, height, alignment, className + '__image');
        homeElement.appendChild(imageElement);
    }
    // Description
    const descriptionElement = (0, $0cd73e606a017c28$export$c46e3d6e889fd01a)(description, descriptionId);
    homeElement.appendChild(descriptionElement);
    // Link
    const linkElement = (0, $e43f2f3861aceab0$export$d43f0d7892afdfe3)(privacyPolicy.url, privacyPolicy.label, '_self', `${className}__link`);
    homeElement.appendChild(linkElement);
    // Decline button
    const declineButtonElement = (0, $bdfcb402607a6bed$export$9b8b2ad360b4fa1b)(decline, ()=>delineAllChoices(), `${className}__button-decline`);
    // Accept button
    const acceptButtonElement = (0, $bdfcb402607a6bed$export$9b8b2ad360b4fa1b)(accept, ()=>acceptAllChoices(), `${className}__button-accept`);
    // Configure button
    const configureButtonElement = (0, $bdfcb402607a6bed$export$9b8b2ad360b4fa1b)(configure, configureCallback, `${className}__button-configure`);
    // Button list
    const buttonListElement = (0, $f414987ffcd7d03b$export$3320100c1b5de582)([
        declineButtonElement,
        acceptButtonElement,
        configureButtonElement
    ]);
    homeElement.appendChild(buttonListElement);
    return modalElement;
}








function $ebf605680fffc750$export$9541e8db76e56340(services) {
    const className = (0, $cf8d6f6baaa06856$export$821aa83695b9c27) + '-list-service';
    const listElement = document.createElement('ul');
    listElement.classList.add(className);
    services.forEach((service)=>{
        const itemElement = document.createElement('li');
        itemElement.classList.add(className + '__item');
        itemElement.appendChild(service);
        listElement.appendChild(itemElement);
    });
    return listElement;
}




/** Capitalize each word of a sentence. */ function $3572aa079e6bb945$export$9a00dee1beb8f576(sentence, separator = ' ') {
    if (!sentence) return '';
    const splitSentence = sentence.split(separator).map((word)=>{
        return word.charAt(0).toUpperCase() + word.slice(1);
    });
    return splitSentence.join(' ');
}



function $88efa49ff6844cb9$export$ade4cf7dfdc949fa(id, name, parentClass) {
    const className = (0, $cf8d6f6baaa06856$export$821aa83695b9c27) + '-checkbox';
    const containerElement = document.createElement('div');
    containerElement.classList.add(className);
    if (parentClass) containerElement.classList.add(parentClass);
    const hiddenCheckboxElement = document.createElement('input');
    hiddenCheckboxElement.classList.add(className + '__hidden');
    hiddenCheckboxElement.id = id;
    hiddenCheckboxElement.type = 'checkbox';
    hiddenCheckboxElement.name = name;
    containerElement.appendChild(hiddenCheckboxElement);
    const visibleCheckboxElement = document.createElement('span');
    visibleCheckboxElement.classList.add(className + '__visible');
    containerElement.appendChild(visibleCheckboxElement);
    return containerElement;
}





function $89eec03cd8814929$export$8db045b003fe2672(name, label, description, privacyPolicy, required, getChoices, url, imageSource) {
    const className = (0, $cf8d6f6baaa06856$export$821aa83695b9c27) + '-service';
    const checkboxId = (0, $cf8d6f6baaa06856$export$821aa83695b9c27) + '-service-checkbox-' + name;
    const choices = getChoices();
    // Service
    const serviceElement = document.createElement('div');
    serviceElement.classList.add(className);
    serviceElement.dataset.serviceName = name;
    // Checkbox
    const checkboxElement = (0, $88efa49ff6844cb9$export$ade4cf7dfdc949fa)(checkboxId, name, className + '__checkbox');
    const hiddenCheckboxElement = checkboxElement.querySelector('input');
    if (choices[name]) hiddenCheckboxElement.checked = true;
    if (required) hiddenCheckboxElement.disabled = true;
    serviceElement.appendChild(checkboxElement);
    // Content
    const contentElement = document.createElement('div');
    contentElement.classList.add(className + '__content');
    // Label container
    const labelContainerElement = document.createElement('div');
    labelContainerElement.classList.add(className + '__label-container');
    contentElement.appendChild(labelContainerElement);
    // Label
    const labelElement = document.createElement('label');
    labelElement.classList.add(className + '__label');
    labelElement.setAttribute('for', checkboxId);
    labelElement.innerText = label;
    labelContainerElement.appendChild(labelElement);
    // Image
    if (imageSource) {
        const imageElement = (0, $2c849848fb05fa8f$export$cebdc09f4d9da75c)(imageSource, '', '100%', undefined, undefined, className + '__image');
        labelContainerElement.appendChild(imageElement);
    }
    // Description
    const descriptionElement = (0, $0cd73e606a017c28$export$c46e3d6e889fd01a)(description);
    contentElement.appendChild(descriptionElement);
    // Link
    if (url) {
        const linkElement = (0, $e43f2f3861aceab0$export$d43f0d7892afdfe3)(url, `${privacyPolicy} ${(0, $3572aa079e6bb945$export$9a00dee1beb8f576)(name)}`, '_blank');
        contentElement.appendChild(linkElement);
    }
    serviceElement.appendChild(contentElement);
    return serviceElement;
}



function $3b9b373b0b7ae5b7$export$b14c3951ea30493a(config, getChoices, sendRecords, setChoice, backCallback, doneCallback) {
    const className = (0, $cf8d6f6baaa06856$export$821aa83695b9c27) + '-settings';
    const titleId = className + '-title';
    const descriptionId = className + '-description';
    const modalElement = (0, $5118421420f951af$export$69bf191433722f78)(titleId, descriptionId);
    const settingsElement = document.createElement('div');
    settingsElement.classList.add(className);
    modalElement.appendChild(settingsElement);
    const headElement = document.createElement('div');
    headElement.classList.add(className + '__head');
    const { title: title, description: description, checkAll: checkAll, uncheckAll: uncheckAll } = config.translations[config.language].settings;
    // Title
    const titleElement = (0, $6a89684121d6b392$export$553f274869ee0a8f)(title, 2, titleId);
    headElement.appendChild(titleElement);
    // Image
    if (config.images?.settings?.source) {
        const { source: source, alternative: alternative, width: width, height: height, alignment: alignment } = config.images.settings;
        const imageElement = (0, $2c849848fb05fa8f$export$cebdc09f4d9da75c)(source, alternative, width, height, alignment, className + '__image');
        headElement.appendChild(imageElement);
    }
    // Description
    const descriptionElement = (0, $0cd73e606a017c28$export$c46e3d6e889fd01a)(description, descriptionId);
    headElement.appendChild(descriptionElement);
    // Decline all button
    const uncheckAllButtonElement = (0, $bdfcb402607a6bed$export$9b8b2ad360b4fa1b)(uncheckAll, ()=>{
        const checkboxElements = settingsElement.querySelectorAll('input');
        checkboxElements.forEach((checkboxElement)=>{
            if (checkboxElement.checked) checkboxElement.click();
        });
    }, `${className}__button-uncheck-all`);
    // Accept all button
    const checkAllButtonElement = (0, $bdfcb402607a6bed$export$9b8b2ad360b4fa1b)(checkAll, ()=>{
        const checkboxElements = settingsElement.querySelectorAll('input');
        checkboxElements.forEach((checkboxElement)=>{
            if (!checkboxElement.checked) checkboxElement.click();
        });
    }, `${className}__button-check-all`);
    // First button list
    const firstButtonListElement = (0, $f414987ffcd7d03b$export$3320100c1b5de582)([
        uncheckAllButtonElement,
        checkAllButtonElement
    ]);
    headElement.appendChild(firstButtonListElement);
    settingsElement.appendChild(headElement);
    const { language: language, services: services } = config;
    const { privacyPolicy: privacyPolicy } = config.translations[language];
    // Services
    if (services) {
        const serviceNames = Object.keys(services);
        const servicesTranslations = config.translations[language].settings?.services;
        if (serviceNames && servicesTranslations) {
            if (serviceNames.length === 1) {
                // Single service
                const serviceName = serviceNames[0];
                const label = servicesTranslations[serviceName].label;
                const description = servicesTranslations[serviceName].description;
                const url = servicesTranslations[serviceName].url;
                const imageSource = services[serviceName].image?.source;
                const required = services[serviceName].required || false;
                if (label && description) {
                    // Service
                    const serviceElement = (0, $89eec03cd8814929$export$8db045b003fe2672)(serviceName, label, description, privacyPolicy.label, required, getChoices, url, imageSource);
                    settingsElement.appendChild(serviceElement);
                }
            } else {
                // Multiple services
                const serviceElements = [];
                serviceNames.forEach((serviceName)=>{
                    const label = servicesTranslations[serviceName].label;
                    const description = servicesTranslations[serviceName].description;
                    const required = services[serviceName].required || false;
                    const url = servicesTranslations[serviceName].url;
                    const imageSource = services[serviceName].image?.source;
                    if (label && description) // Service
                    serviceElements.push((0, $89eec03cd8814929$export$8db045b003fe2672)(serviceName, label, description, privacyPolicy.label, required, getChoices, url, imageSource));
                });
                // Service list
                const serviceListElement = (0, $ebf605680fffc750$export$9541e8db76e56340)(serviceElements);
                settingsElement.appendChild(serviceListElement);
            }
        }
    }
    const { back: back, done: done } = config.translations[config.language].settings;
    // Back button
    const backButtonElement = (0, $bdfcb402607a6bed$export$9b8b2ad360b4fa1b)(back, backCallback);
    // Done button
    const doneButtonElement = (0, $bdfcb402607a6bed$export$9b8b2ad360b4fa1b)(done, ()=>{
        const checkboxElements = settingsElement.querySelectorAll('input');
        checkboxElements.forEach((checkboxElement)=>{
            setChoice(checkboxElement.name, checkboxElement.checked);
        });
        // Send new records
        sendRecords();
        doneCallback();
    });
    // Second button list
    const secondButtonListElement = (0, $f414987ffcd7d03b$export$3320100c1b5de582)([
        backButtonElement,
        doneButtonElement
    ]);
    settingsElement.appendChild(secondButtonListElement);
    return modalElement;
}



const $58a1b3ba1bbe9f2b$var$defaultConfig = {
    translations: {
        en: {
            privacyPolicy: {
                label: 'Privacy policy'
            },
            home: {
                title: 'Cookie management',
                description: 'By allowing third-party services, you accept the creation and use of cookies as well as the tracking technologies necessary for their usage.',
                decline: 'Decline',
                configure: 'Configure',
                accept: 'Accept'
            },
            settings: {
                title: 'Our cookies',
                description: 'Here you can select which services are allowed to use cookies.',
                checkAll: 'Check all',
                uncheckAll: 'Uncheck all',
                back: 'Back',
                done: 'Done'
            }
        },
        fr: {
            privacyPolicy: {
                label: "Politique de confidentialit\xe9"
            },
            home: {
                title: 'Gestion des cookies',
                description: "En autorisant des services tiers, vous acceptez la cr\xe9ation et l'utilisation de cookies ainsi que des technologies de suivi n\xe9cessaires \xe0 leur utilisation.",
                decline: 'Refuser',
                configure: 'Configurer',
                accept: 'Accepter'
            },
            settings: {
                title: 'Nos cookies',
                description: "Ici vous pouvez s\xe9lectionner quels services sont autoris\xe9s \xe0 utiliser des cookies.",
                checkAll: 'Tout cocher',
                uncheckAll: "Tout d\xe9cocher",
                back: 'Retour',
                done: 'Terminer'
            }
        }
    }
};
const $58a1b3ba1bbe9f2b$var$defaultStorage = {
    uuid: self.crypto.randomUUID(),
    choices: {},
    timestamp: new Date().getTime()
};
class $58a1b3ba1bbe9f2b$export$2e2bcd8739ae039 {
    constructor(userConfig){
        this.lastRecordedChoices = {};
        this.containerOpenClass = `${0, $cf8d6f6baaa06856$export$821aa83695b9c27}-container--open`;
        // Create final config
        this.config = (0, $4xgRo$lodashmerge)($58a1b3ba1bbe9f2b$var$defaultConfig, userConfig);
        // Get string from local storage
        const storageString = localStorage.getItem((0, $cf8d6f6baaa06856$export$43d7bf4a2adcea1e));
        if (storageString) // Parse storage string
        this.storage = JSON.parse(storageString);
        else {
            // Create default storage
            this.storage = structuredClone($58a1b3ba1bbe9f2b$var$defaultStorage);
            // Send default records
            this.sendRecords();
        }
        // Save current choices for comparison
        this.lastRecordedChoices = structuredClone(this.storage.choices);
        // Check that each service has a matching choice
        Object.entries(this.config.services).forEach(([serviceName, service])=>{
            // If the service doesn't have a matching choice
            if (this.storage.choices[serviceName] === undefined) {
                // If the service is required
                if (service.required) // The choice is set to "true"
                this.setChoice(serviceName, true);
                else // The choice is set to "null" to query the user
                this.setChoice(serviceName, null);
            } else // Execute service callback
            if (service.callback) service.callback(this.storage.choices[serviceName]);
        });
        // Check that each choice has a matching service
        Object.entries(this.storage.choices).forEach(([serviceName])=>{
            // If the choice doesn't have a mathching service
            if (!this.config.services[serviceName]) // Delete choice
            this.deleteChoice(serviceName);
        });
        // Send new records
        this.sendRecords();
        // Render container
        this.containerElement = document.createElement('div');
        this.containerElement.classList.add((0, $cf8d6f6baaa06856$export$821aa83695b9c27) + '-container');
        document.body.prepend(this.containerElement);
        // Render home
        this.homeElement = (0, $4261e957589a8239$export$5e5c8210e5686582)(this.config, ()=>this.declineAllChoices(), ()=>this.acceptAllChoices(), ()=>this.showSettings());
        this.containerElement.appendChild(this.homeElement);
        // Render settings
        this.settingsElement = (0, $3b9b373b0b7ae5b7$export$b14c3951ea30493a)(this.config, ()=>this.getChoices(), ()=>this.sendRecords(), (serviceName, value)=>this.setChoice(serviceName, value), ()=>this.showHome(true), ()=>this.close());
        this.containerElement.appendChild(this.settingsElement);
        // Check if a choice is required
        let choiceRequired = false;
        Object.values(this.storage.choices).forEach((value)=>{
            if (value === null) choiceRequired = true;
        });
        if (choiceRequired) this.open();
    }
    getChoices() {
        return this.storage.choices;
    }
    setChoice(serviceName, value) {
        // Check if the new value is different from the current one
        if (this.storage.choices[serviceName] === value) return;
        // Update class property
        this.storage.choices[serviceName] = value;
        this.storage.timestamp = new Date().getTime();
        // Update local storage
        localStorage.setItem((0, $cf8d6f6baaa06856$export$43d7bf4a2adcea1e), JSON.stringify(this.storage));
        // Update checkbox
        if (this.settingsElement) {
            const checkboxElement = this.settingsElement.querySelector(`input[name=${serviceName}]`);
            checkboxElement.checked = !!value;
        }
        // Notify callback with new choice
        if (this.config.services && this.config.services[serviceName] && this.config.services[serviceName].callback) this.config.services[serviceName].callback(this.storage.choices[serviceName]);
    }
    sendRecords() {
        const { recordsUrl: recordsUrl } = this.config;
        if (recordsUrl) {
            // Check if the current choices are identical to the last recorded ones
            if (JSON.stringify(this.lastRecordedChoices) === JSON.stringify(this.storage.choices)) return;
            // Send records to endpoint
            fetch(recordsUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(this.storage)
            });
            // Update last recorded choices
            this.lastRecordedChoices = structuredClone(this.storage.choices);
        }
    }
    deleteChoice(serviceName) {
        // Update class property
        delete this.storage.choices[serviceName];
        // Update local storage
        localStorage.setItem((0, $cf8d6f6baaa06856$export$43d7bf4a2adcea1e), JSON.stringify(this.storage));
    }
    acceptAllChoices() {
        // Set the choise to "true" for each service
        Object.keys(this.config.services).forEach((serviceName)=>{
            if (this.storage.choices[serviceName] !== true) this.setChoice(serviceName, true);
        });
        // Send new records
        this.sendRecords();
        this.close();
    }
    declineAllChoices() {
        // Set the choise to "false" for each service that isn't required
        Object.entries(this.config.services).forEach(([serviceName, service])=>{
            if (!service.required && this.storage.choices[serviceName] !== false) this.setChoice(serviceName, false);
        });
        // Send new records
        this.sendRecords();
        this.close();
    }
    showHome(back) {
        this.homeElement.style.display = 'flex';
        this.settingsElement.style.display = 'none';
        if (back) {
            // Focus configure button
            const buttonElement = this.homeElement.querySelector(`.${(0, $cf8d6f6baaa06856$export$821aa83695b9c27)}-home__button-configure`);
            buttonElement.focus();
        } else {
            // Focus link
            const linkElement = this.homeElement.querySelector(`.${(0, $cf8d6f6baaa06856$export$821aa83695b9c27)}-home__link`);
            linkElement.focus();
        }
    }
    showSettings(serviceName) {
        this.homeElement.style.display = 'none';
        this.settingsElement.style.display = 'flex';
        if (serviceName) {
            if (this.config.services[serviceName]) {
                // Focus checkbox matching service
                const checkboxElement = this.settingsElement.querySelector(`input[name=${serviceName}]`);
                checkboxElement.focus();
            } else {
                console.error(`Could not find service "${serviceName}"`);
                // Focus uncheck all button
                const buttonElement = this.settingsElement.querySelector(`.${(0, $cf8d6f6baaa06856$export$821aa83695b9c27)}-settings__button-uncheck-all`);
                buttonElement.focus();
            }
        } else {
            // Focus uncheck all button
            const buttonElement = this.settingsElement.querySelector(`.${(0, $cf8d6f6baaa06856$export$821aa83695b9c27)}-settings__button-uncheck-all`);
            buttonElement.focus();
        }
    }
    open(serviceName) {
        this.containerElement.classList.add(this.containerOpenClass);
        this.containerElement.inert = false;
        if (serviceName) this.showSettings(serviceName);
        else this.showHome();
    }
    close() {
        this.containerElement.inert = true;
        this.containerElement.classList.remove(this.containerOpenClass);
    }
}


export {$58a1b3ba1bbe9f2b$export$2e2bcd8739ae039 as default};
//# sourceMappingURL=index.js.map
